/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Street
 */
export interface Street {
    /**
     * 
     * @type {string}
     * @memberof Street
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Street
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof Street
     */
    streetName: string;
}

/**
 * Check if a given object implements the Street interface.
 */
export function instanceOfStreet(value: object): value is Street {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('streetName' in value) || value['streetName'] === undefined) return false;
    return true;
}

export function StreetFromJSON(json: any): Street {
    return StreetFromJSONTyped(json, false);
}

export function StreetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Street {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'number': json['number'] == null ? undefined : json['number'],
        'streetName': json['streetName'],
    };
}

export function StreetToJSON(json: any): Street {
    return StreetToJSONTyped(json, false);
}

export function StreetToJSONTyped(value?: Street | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'number': value['number'],
        'streetName': value['streetName'],
    };
}

